import { Directive, ElementRef, Input, OnChanges, OnInit, SimpleChanges } from "@angular/core";

@Directive({
  selector: "[ngxAccessControl]",
})
export class AccessControlDirective implements OnChanges{
  @Input("moduleType") moduleType: string;
  @Input("accessType") accessType: string;
  // roleId: string;
  // accessControls: any;

  constructor(private elementRef: ElementRef) {}

  // ngOnInit() {
  //   this.checkAccess();
  // }

  ngOnChanges(changes: SimpleChanges) {
    if (this.moduleType && this.accessType) {
      this.checkAccess();
    }
  }
  
  // async checkAccess() {
  //   const accessControls: any = JSON.parse(localStorage.getItem("roles"));
  //   const module: any = accessControls?.find((access) => {
  //     if (access.module === this.moduleType) {
  //       return access.module;
  //     }
  //   });

  //   this.elementRef.nativeElement.style.display = module[this.accessType]
  //     ? "block"
  //     : "none";
  // }
  checkAccess() {
    try {
      const accessControls = JSON.parse(localStorage.getItem('roles') || '[]');
  
      // console.log('Checking access for module:', this.moduleType, 'accessType:', this.accessType);
      // console.log('Loaded roles from localStorage:', accessControls);
  
      const module = accessControls.find((access: any) => access.module === this.moduleType);
  
      if (!module) {
        console.warn(`No access config found for module "${this.moduleType}"`);
      }
  
      const hasAccess = !!module && module[this.accessType] === true;
  
      // console.log(`Access check for [${this.moduleType} - ${this.accessType}]:`, hasAccess);
  
      this.elementRef.nativeElement.style.display = hasAccess ? 'block' : 'none';
    } catch (error) {
      console.error('AccessControlDirective error:', error);
      this.elementRef.nativeElement.style.display = 'none';
    }
  }
  
  
}
